module.exports = {
      id: "comm-health-usage",
      viewBox: "0 0 321.539 50.773",
      url: "/" + "sprite-8d2e5ebc566e02833b7f09cd596911c9.svg#comm-health",
      toString: function () {
        return this.url;
      }
    }